import React, { createContext, useState, useEffect } from 'react';
import { auth } from '../FirebaseAuth';

// Initial mock data is now managed here
const initialStudents = [
    { id: 1, name: 'John Doe', email: 'john.doe@example.com' },
    { id: 2, name: 'Jane Smith', email: 'jane.smith@example.com' },
];
const initialTeachers = [
    { id: 1, name: 'Mr. Smith', email: 'smith@example.com' },
    { id: 2, name: 'Ms. Jones', email: 'jones@example.com' },
];
const initialCourses = [
    { id: 1, name: 'Mathematics', teacher: 'Mr. Smith' },
    { id: 2, name: 'History', teacher: 'Ms. Jones' },
];
const initialAttendance = [
    { id: 1, student: 'John Doe', status: 'Present' },
    { id: 2, student: 'Jane Smith', status: 'Absent' },
];
const initialAssessments = [
    { id: 1, name: 'Mid-Term Exam' },
    { id: 2, name: 'Final Exam' },
];

export const SchoolContext = createContext();

export const SchoolProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [school, setSchool] = useState(null);
    const [students, setStudents] = useState(initialStudents);
    const [teachers, setTeachers] = useState(initialTeachers);
    const [courses, setCourses] = useState(initialCourses);
    const [attendance, setAttendance] = useState(initialAttendance);
    const [assessments, setAssessments] = useState(initialAssessments);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setUser(user);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const value = {
        user, loading,
        school, setSchool,
        students, setStudents,
        teachers, setTeachers,
        courses, setCourses,
        attendance, setAttendance,
        assessments, setAssessments,
    };

    return (
        <SchoolContext.Provider value={value}>
            {children}
        </SchoolContext.Provider>
    );
};
